export var WhoAmIResponseCode;
(function (WhoAmIResponseCode) {
    WhoAmIResponseCode[WhoAmIResponseCode["Cached"] = 2] = "Cached";
    WhoAmIResponseCode[WhoAmIResponseCode["InvalidAuthnId"] = 3] = "InvalidAuthnId";
    WhoAmIResponseCode[WhoAmIResponseCode["MissingAuthnId"] = 1] = "MissingAuthnId";
    WhoAmIResponseCode[WhoAmIResponseCode["Throttled"] = 429] = "Throttled";
    WhoAmIResponseCode[WhoAmIResponseCode["Uncached"] = 4] = "Uncached";
})(WhoAmIResponseCode || (WhoAmIResponseCode = {}));
//# sourceMappingURL=whoami-response-code.js.map